import { useState } from 'react';
import HormonesScreen from './HormonesScreen';
import SymptomsScreen from './SymptomsScreen';
import InsightsScreen from './InsightsScreen';
import CareScreen from './CareScreen';

/**
 * CareHubScreen — Sprint 1.5 restructure of the Care tab.
 *
 * Segmented control with 4 sections:
 *   • Hormones — existing HormonesScreen (unchanged)
 *   • Symptoms — existing SymptomsScreen (unchanged)
 *   • Insights — existing InsightsScreen (unchanged)
 *   • Wellness — the FULL existing CareScreen (personalized care
 *                recommendations — diet, lifestyle, sleep, movement).
 *                Nothing has been replaced or reduced to a placeholder.
 *
 * No functional changes to the four underlying screens. Pure
 * navigation restructure per Sprint 1.5 spec.
 */
const SECTIONS = [
  { id: 'hormones', label: 'Hormones' },
  { id: 'symptoms', label: 'Symptoms' },
  { id: 'insights', label: 'Insights' },
  { id: 'wellness', label: 'Wellness' },
];

export default function CareHubScreen({ userId, initialSection = 'hormones' }) {
  const [section, setSection] = useState(
    SECTIONS.some((s) => s.id === initialSection) ? initialSection : 'hormones'
  );

  return (
    <div data-testid="care-hub-screen">
      <div
        style={{
          display: 'flex', gap: 6, background: '#F5F3FF',
          padding: 6, borderRadius: 14, margin: '12px 16px 4px',
        }}
        data-testid="care-subtab-nav"
      >
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            onClick={() => setSection(s.id)}
            data-testid={`care-subtab-${s.id}`}
            role="tab"
            aria-selected={section === s.id}
            data-active={section === s.id ? 'true' : 'false'}
            style={{
              flex: 1, padding: '8px 6px', borderRadius: 10, border: 'none',
              fontSize: 12.5, fontWeight: 700, cursor: 'pointer',
              background: section === s.id ? '#fff' : 'transparent',
              color: section === s.id ? '#6D5EF5' : '#8A8A9A',
              boxShadow: section === s.id ? '0 2px 8px rgba(109,94,245,0.12)' : 'none',
              transition: 'all 0.18s ease', fontFamily: 'inherit',
            }}
          >
            {s.label}
          </button>
        ))}
      </div>

      <div style={{ marginTop: 4 }}>
        {section === 'hormones' && <HormonesScreen userId={userId} />}
        {section === 'symptoms' && <SymptomsScreen userId={userId} />}
        {section === 'insights' && <InsightsScreen userId={userId} />}
        {section === 'wellness' && <CareScreen userId={userId} />}
      </div>
    </div>
  );
}
